export const NumericOnly = /^[0-9]*$/;
export const LowercaseOnly =
  /^[a-z0-9àèéìòùáóú!@%#\*$&()<>?;:'\[\]\{\}\\-`.+,/\ "]*$/;
export const AlphabeticOnly = /^[a-zA-Zàèéìòùáóú]*$/;
export const AlphabeticAndNumericOnly = /^[0-9a-zA-Zàèéìòùáóú]*$/;
export const AlphabeticSpacedOnly = /^[a-zA-Zàèéìòùáóú ]*$/;
export const AlphabeticSpacedWithApostropheOnly = /^[a-zA-Zàèéìòùáóú' ]*$/;

// ADDRESS REGEX
export const ValidAddressRegex =
  /^\b(via|contrada|corso|viale|piazza|piazzale|vicolo|strada|largo|c.so|vico|galleria)\b ([a-zA-Z0-9àèéìòùáóú',.\-]+\s)+(\d+|snc)[a-zA-Z0-9',./\\-s]*$/i; // NOSONAR

// NAME REGEX
export const ValidNamesRegex = /^[a-zA-Zàèéìòùáóú ']+$/;
const ValidNamesRegexSource = ValidNamesRegex.source;
export const ValidNamesRegexString = ValidNamesRegexSource.slice(
  0,
  ValidNamesRegexSource.length,
);

// PASSWORD REGEX
export const ValidPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[,.;:'+\-<>=|?!"$%()^_*#@\[\]{}\/])([a-zA-Z0-9,.;:'+\-<>=|?!"$%()^_*#@\[\]{}\/]{10,24})$/;

export const AbsoluteUrlRegEx = new RegExp("^(?:[a-z+]+:)?//", "i");

export const allRegexMapper = {
  numericOnly: NumericOnly,
  alphabeticOnly: AlphabeticOnly,
  alphabeticAndNumericOnly: AlphabeticAndNumericOnly,
  alphabeticSpaceOnly: AlphabeticSpacedOnly,
  alphabeticSpacedWithApostropheOnly: AlphabeticSpacedWithApostropheOnly,
  lowercaseOnly: LowercaseOnly,
};

export const stringToRegex = (str: string) => {
  const mainMatch = str.match(/\/(.+)\/.*/);
  const optsMatch = str.match(/\/.+\/(.*)/);
  if (mainMatch) {
    // Main regex
    const main = mainMatch[1];
    // Regex options
    let opts = "";
    if (optsMatch) {
      opts = optsMatch[1];
    }
    return new RegExp(main, opts);
  }

  // Compiled regex
  return new RegExp(str);
};
